import { icSearch, icInfo } from '@vivareal/lina-icons'

import {
  getAdvertisers,
  getAdvertisersGroup,
  getSuggestionsValues,
} from '@/utils/transformers/advertiser-suggestions'
import locationsAPI from '@/api/new-locations'

const ozLoading = () => import(/* webpackChunkName: "oz-loading" */ '@/components/oz-loading')

const FIELDS_TEXT = {
  account: 'Imobiliárias',
}

export default {
  name: 'oz-advertiser-id',

  props: {
    delay: { type: Number, default: 500 },
    minQuery: { type: Number, default: 3 },
    filters: { type: Object, required: true },
  },

  data () {
    return {
      checkedAdvertisers: [],
      inputValueLength: 0,
      showWarningBox: false,
      query: '',
      icons: {
        icInfo,
        icSearch,
      },
      advertisers: [],
      savedAdvertisers: [],
      advertiserIdSugestionsLastSearch: [],
      hasAdvertisers: false,
      timeout: null,
      seeMoreClicked: false,
      label: 'Anunciado por',
      placeholder: 'Digite o anunciante',
      messageAddressNotFound: 'Não há resultados para esta imobiliária',
    }
  },

  created () {
    const { advertiserId, advertiserName } = this.filters
    const ids = Array.isArray(advertiserId) ? advertiserId : advertiserId?.split(',') || []
    const names = Array.isArray(advertiserName) ? advertiserName : advertiserName?.split(',') || []

    ids.forEach((id, index) => {
      let value

      try {
        value = JSON.stringify({ name: names[index], id })

        this.savedAdvertisers.push({
          text: {
            id,
            name: names[index],
          },
          value,
        })
        this.checkedAdvertisers.push(value)
      } catch (error) {
        throw new Error('JSON stringify error when try to get suggestions values')
      }
    })
  },

  computed: {
    placeholderText () {
      return this.savedAdvertisers[0]?.text.name || this.placeholder
    },

    suggestions () {
      const newSuggestions = this.limitSearch ? this.advertisers.filter((i) => i.group.name === 'account') : []

      return newSuggestions.length ? newSuggestions : this.advertiserIdSugestionsLastSearch
    },

    searching () {
      const haveMinQueryInput = this.query.length > this.minQuery
      const haveSuggestions = this.suggestions.length > 0

      return haveMinQueryInput && !haveSuggestions && !this.showWarningBox
    },

    buttonCounter () {
      const advertisers = this.checkedAdvertisers.length

      if (advertisers === 1) return `${advertisers}`
      if (advertisers > 1) {
        const countAdvertisers = advertisers - 1
        return `+${countAdvertisers}`
      }

      return null
    },

    seeMore () {
      return this.savedAdvertisers.length > 2
    },

    seeMoreText () {
      const savedAdvertisersShowed = 2

      return this.seeMoreClicked ? 'Ver menos' : `Ver mais (${this.savedAdvertisers.length - savedAdvertisersShowed})`
    },

    limitSearch () {
      const LIMIT_SEARCH_LOCATION = 5
      return this.savedAdvertisers?.length < LIMIT_SEARCH_LOCATION
    },

    alertMessage () {
      if (!this.limitSearch) {
        return 'Você atingiu o limite de imobiliárias'
      }

      if (this.showWarningBox) {
        return this.messageAddressNotFound
      }

      return ''
    },

    showAlertMessage () {
      return !this.searching && (!this.limitSearch || this.showWarningBox)
    },
  },

  watch: {
    checkedAdvertisers (advertisers) {
      if (this.checkedAdvertisers.length) {
        this.query = ''
      }

      this.seeMoreClicked = false
      this.autocompleteEmit(advertisers.map((advertiser) => (JSON.parse(advertiser))))
    },

    advertisers (newAdvertisers) {
      this.advertisers = newAdvertisers
      this.shouldShowWarningBox()
    },
  },

  methods: {
    onInput (value) {
      this.inputValueLength = value.length
      this.query = value
      this.autocompleteInput()
    },

    clearAll () {
      this.savedAdvertisers = []
      this.checkedAdvertisers = []
      this.query = ''
      this.$refs.dropdown.close()
    },

    shouldSeeMore () {
      this.seeMoreClicked = !this.seeMoreClicked
    },

    shouldShowWarningBox () {
      this.showWarningBox = this.advertisers.length === 0 && this.inputValueLength > this.minQuery
    },

    autocompleteInput () {
      clearTimeout(this.timeout)

      this.autocompleteSearchAdvertisers()
    },

    autocompleteEmit (advertisers) {
      const ids = []
      const names = []

      advertisers.filter((item) => {
        ids.push(item.id)
        names.push(item.name)

        return {
          ids,
          names,
        }
      })

      if (!this.hasAdvertisers) {
        this.advertiserIdSugestionsLastSearch = this.suggestions
        this.$emit('filters:update', { advertiserId: ids.join(','), advertiserName: names.join(',') })
      }

      this.autocompleteSaveAdvertisers()
    },

    autocompleteSaveAdvertisers () {
      const advertisers = []

      this.checkedAdvertisers.forEach((value) => {
        const advertiser = JSON.parse(value)
        advertisers.push(getSuggestionsValues('account', [{ advertiser }])[0])
      })

      this.savedAdvertisers = advertisers
      this.hasAdvertisers = false
    },

    autocompleteSearchAdvertisers () {
      if (this.query.length < this.minQuery) {
        this.advertisers = []
        return
      }

      this.timeout = setTimeout(() => {
        const { business } = this.filters
        const filters = { ...this.filters }

        locationsAPI.get(this.$store, filters, this.query, business).then((response) => {
          const advertisers = getAdvertisers(response.data, ['account'])
          this.advertisers = getAdvertisersGroup(advertisers, FIELDS_TEXT)
        })
      }, this.delay)
    },
  },

  components: {
    ozLoading,
  },
}
